const nodeGetDeepestChildrenValues = (node) => {
    let children = [];
    if (node.children) {
        for (const child of node.children) {
            if (child.children) {
                children = [...children, ...nodeGetDeepestChildrenValues(child)];
            }
            else {
                children.push(child.value);
            }
        }
    }
    return children;
};
export const gatherAllChildrenNodes = (treeData) => {
    let children = [];
    treeData.forEach((node) => {
        children = children.concat(nodeGetDeepestChildrenValues(node));
    });
    return children;
};
//# sourceMappingURL=index.js.map